import humps from 'humps'
import { createApp } from '@app/adapters/create-app'

import AuditLog from '@app/application/ledger-audit-log/sections/audit-log'
import groupAuditsPerDay from '@app/application/ledger-audit-log/utils/group-audits-per-day'

const setupLedgerAuditLog = () => {
  onDomLoad(function ($dom) {
    $dom.find("[data-behaviour='group-ledger-audits']").each(function () {
      const { wrappedAudits } = this.dataset
      const audits = humps.camelizeKeys(JSON.parse(wrappedAudits))
      const timestampGetter = (item) => item.audit.createdAt

      createApp(AuditLog, {
        wrappedAuditsPerDay: groupAuditsPerDay({ audits, timestampGetter }),
      }).mount(this)
    })
  })
}
export default setupLedgerAuditLog
